import { IconButton, TableCell, TableRow, Typography } from '@mui/material';
import React, { FC, memo } from 'react';
import { Iconify } from 'src/UIKit/Iconify';
import { useUiContext } from 'src/UIProvider';
import {useMenstrualCycleTableItem} from "../../../presenters/useMenstrualCycleTableItem";
import { styles } from './styles';

interface IProps {
    type: string;
};

export const MenstrualCyclesTableRow: FC<IProps> = memo(({ type }) => {
    const { t } = useUiContext();
    const { onEdit } = useMenstrualCycleTableItem(type);

    return (
        <>
            <TableRow hover  >
                <TableCell component="th" scope="row" align="left" width="35%">
                    <Typography variant="subtitle2" sx={styles.text}>
                        {t(`menstrualCycles.${type}`)}
                    </Typography>
                </TableCell>
                <TableCell component='th' align='right'>
                    <IconButton size="large" color="inherit" onClick={onEdit}>
                        <Iconify icon={'eva:edit-fill'} />
                    </IconButton>
                </TableCell>
            </TableRow>
        </>
    );
})
